import Skeleton from '@mui/material/Skeleton';
import Grid from '@mui/material/Grid';
import useMediaQuery from '@mui/material/useMediaQuery';
import useTheme from '@mui/system/useTheme';
import { Divider } from '@mui/material';
import { AdvisorsWrapper } from './styled';

function AdvisorCardSkeleton(): JSX.Element {
  const theme = useTheme();

  const avatarDimension = useMediaQuery(theme.breakpoints.up('sm')) ? 130 : 59;

  return (
    <AdvisorsWrapper>
      <Grid container columns={16} alignContent="flex-end" spacing={1}>
        <Grid item xs={16} md={10} p={2}>
          <Grid container columns={16} columnSpacing={5}>
            <Grid
              id="avatar"
              item
              xs={4}
              sm={3}
              md={4}
              alignSelf="center"
              justifyContent="center">
              <Skeleton
                variant="circular"
                height={avatarDimension}
                width={avatarDimension}
                sx={{
                  margin: 'auto'
                }}
              />
            </Grid>
            <Grid item xs={12} sm={13} md={12}>
              <Skeleton
                id="advisor-name"
                variant="text"
                height={40}
                width="50%"
              />
              <Skeleton
                id="advisor-title"
                variant="text"
                height={30}
                width="75%"
              />
              <Skeleton
                sx={{
                  display: {
                    xs: 'none',
                    sm: 'none',
                    md: 'block',
                    lg: 'block',
                    xl: 'block'
                  }
                }}
                id="advisor-description"
                variant="text"
                width="100%"
                height={100}
              />
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={16} md={3} p={2}>
          <Grid container columns={16} spacing={4}>
            <Grid item xs={8} sm={8} md={16}>
              <Skeleton id="rating" variant="text" height={30} />
              <Skeleton
                id="reviews"
                variant="text"
                height={20}
                sx={{ display: { xs: 'none', sm: 'none' } }}
              />
            </Grid>
            <Grid
              item
              md={16}
              sx={{
                display: {
                  xs: 'none',
                  sm: 'none',
                  md: 'block',
                  lg: 'block',
                  xl: 'block'
                }
              }}>
              <Skeleton id="readings-count" variant="text" height={30} />
              <Skeleton id="readings-label" variant="text" height={20} />
            </Grid>
            <Grid
              item
              md={16}
              sx={{
                display: {
                  xs: 'none',
                  sm: 'none',
                  md: 'block',
                  lg: 'block',
                  xl: 'block'
                }
              }}>
              <Skeleton id="year" variant="text" height={30} />
              <Skeleton id="advisor-since" variant="text" height={20} />
            </Grid>
            <Grid
              item
              xs={8}
              sm={8}
              sx={{
                display: {
                  xs: 'block',
                  sm: 'block',
                  md: 'none',
                  lg: 'none',
                  xl: 'none'
                }
              }}>
              <Skeleton id="offer" variant="text" />
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={16} md={3} p={2}>
          <Grid
            sx={{
              display: {
                xs: 'none',
                sm: 'none',
                md: 'block',
                lg: 'block',
                xl: 'block'
              }
            }}>
            <Skeleton
              id="price"
              variant="text"
              height={50}
              width="50%"
              sx={{
                marginLeft: 1
              }}
            />
          </Grid>
          <Grid container columns={16} spacing={0}>
            <Grid item xs={8} sm={8} md={16} p={1}>
              <Skeleton id="call" height={50} />
            </Grid>
            <Grid item xs={8} sm={8} md={16} p={1}>
              <Skeleton id="chat" height={50} />
            </Grid>
          </Grid>
        </Grid>
      </Grid>
      <Divider />
    </AdvisorsWrapper>
  );
}

export default AdvisorCardSkeleton;
